"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("../../../icon"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

/* eslint-disable react/no-multi-comp */
var NavigationGroup = function NavigationGroup(_ref) {
  var title = _ref.title,
      _handleClick = _ref.handleClick,
      isMenuOpen = _ref.isMenuOpen,
      menuIndex = _ref.menuIndex,
      children = _ref.children,
      className = _ref.className,
      isSingleItem = _ref.isSingleItem;
  return isSingleItem ? _react.default.Children.map(children, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      handleClick: function handleClick() {
        return _handleClick(null);
      },
      isSingleItem: true,
      child: child
    });
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.NavigationGroup
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)(_indexModule.default.title, (0, _defineProperty2.default)({}, _indexModule.default.active, isMenuOpen)),
    role: "menuitem",
    "aria-label": "Open ".concat(title),
    onClick: function onClick() {
      return _handleClick(menuIndex);
    }
  }, title, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: isMenuOpen ? 'chevron-up' : 'chevron-down',
    size: "small",
    className: _indexModule.default.navigationCarrot,
    role: "presentation"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_indexModule.default.childrenWrapper, className, (0, _defineProperty2.default)({}, _indexModule.default.menuOpen, isMenuOpen)),
    role: "menu"
  }, _react.default.Children.map(children, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      handleClick: function handleClick() {
        return _handleClick(null);
      }
    });
  })));
};

NavigationGroup.defaultProps = {
  isMenuOpen: false,
  menuIndex: 0
};
NavigationGroup.propTypes = {
  title: _propTypes.default.string,
  isMenuOpen: _propTypes.default.bool,
  handleClick: _propTypes.default.func.isRequired,
  menuIndex: _propTypes.default.number,
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  isSingleItem: _propTypes.default.bool
};
var _default = NavigationGroup;
exports.default = _default;